import { render, staticRenderFns } from "./scxxzyjsxy.vue?vue&type=template&id=5d7118d1&scoped=true&"
import script from "./scxxzyjsxy.vue?vue&type=script&lang=js&"
export * from "./scxxzyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./scxxzyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./scxxzyjsxy.vue?vue&type=style&index=1&id=5d7118d1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7118d1",
  null
  
)

export default component.exports